import React, { useState, useContext } from "react";
import { useNavigate, useLocation, NavLink } from "react-router-dom"; // Import NavLink
import {
  Tabs,
  Tab,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import LoginPopup from "../auth/LoginPopup";
import logo from "../../assets/logo.jpeg";
import { AuthContext } from "../../context/AuthContext";
// import { useTheme } from "../../context/ThemeContext";
import { useTheme } from "@mui/system";
import "./Layout.css";
import NotificationBell from "../common/NotificationBell";

const NavBar = () => {
  const theme = useTheme();
  const { isAuthenticated, role } = useContext(AuthContext);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleTabChange = (event, newValue) => {
    if (!isAuthenticated && (newValue === "/castingcalls" || newValue === "/actors" || newValue === "/crew")) {
      setRedirectTo(newValue);
      setIsLoginOpen(true);
    } else {
      navigate(newValue);
    }
  };

  const handleClick = () => {
    let roleType = "actor"; // Default role

    // Determine role based on current path
    if (location.pathname.includes("/actors")) {
      roleType = "actor";
    } else if (location.pathname.includes("/crew")) {
      roleType = "crew";
    } else if (location.pathname.includes("/castingdirectors") || location.pathname.includes("/producer")) {
      roleType = "castingdirectors";
    }
    navigate("/register", { state: { role: roleType } });
  };

  const handleClickSubscribe = () => {
    navigate("/subscriptions");
  };

  const handleClickCastingCallCreate = () => {
    navigate("/castingcalls/create");
  };

  // Determine the active tab based on the URL
  const getActiveTab = () => {
    if (location.pathname.startsWith("/castingcalls")) {
      return "/castingcalls";
    } else if (location.pathname.startsWith("/actors")) {
      return "/actors";
    } else if (location.pathname.startsWith("/crew")) {
      return "/crew";
    } else if (location.pathname.startsWith("/castingdirectors")) {
      return "/castingdirectors";
    } else if (location.pathname.startsWith("/reviews")) {
      return "/reviews";
    }
    return false;
  };

  // console.log("Current Role:", role, isAuthenticated);

  return (
    <div className="navbar-full-wrapper">
      <div className="navbar-container">
        <NavLink to="/">
          <img src={logo} alt="" className="logo" />
        </NavLink>
        <Tabs
          value={getActiveTab()}
          onChange={handleTabChange}
          textColor="#6e0605"
          indicatorColor="primary"
          sx={{
            maxWidth: "502px",
            
          }}
        >
          <Tab
            sx={{ 
              background: "none", 
              "&.Mui-selected": {
                color: "#6E0506 !important",
                fontWeight: "bold",
              },
              "&:hover": {
                  background: "none !important", // Change this to your desired hover color
                  color: "#6E0506 !important"
                },
            }}
            label="Casting Calls"
            // style={{
            //   marginLeft: "25px"
            // }}
            value="/castingcalls"
          />
          {(!isAuthenticated || role !== "producer") && (
            <Tab
              sx={{
                background: "none",
                "&.Mui-selected": {
                  color: "#6E0506 !important",
                  fontWeight: "bold",
                },
                "&:hover": {
                  background: "none !important", // Change this to your desired hover color
                  color: "#6E0506 !important"
                },
              }}
              label="Actors"
              value="/actors"
            />
          )}
          {/* {(!isAuthenticated || role !== "director") && ( */}
            <Tab
              sx={{
                background: "none",
                "&.Mui-selected": {
                  color: "#6E0506 !important",
                  fontWeight: "bold",
                },
                "&:hover": {
                  background: "none !important", 
                  color: "#6E0506 !important"
                },
              }}
              label="Crew"
              value="/crew"
            />
          {/* )} */}
          {!isAuthenticated && (
            <Tab
              sx={{
                background: "none",
                "&.Mui-selected": {
                  color: "#6E0506 !important",
                  fontWeight: "bold",
                },
                "&:hover": {
                  background: "none !important", // Change this to your desired hover color
                  color: "#6E0506 !important"
                },
              }}
              label="Casting Directors"
              value="/castingdirectors"
            />
          )}
          <Tab
            sx={{
              background: "none",
              "&.Mui-selected": {
                color: "#6E0506 !important",
                fontWeight: "bold",
              },
              "&:hover": {
                  background: "none !important", // Change this to your desired hover color
                  color: "#6E0506 !important"
                },
            }}
            label="Reviews"
            value="/reviews"
          />
        </Tabs>
        <div className="navLink-container">
          {!isAuthenticated && (
            <NavLink
              to="/login"
              className="navLink"
              style={{ color: "#6e0506" }}
              onClick={(e) => {
                e.preventDefault();
                setIsLoginOpen(true);
              }}
            >
              Login
            </NavLink>
          )}
          {!isAuthenticated && (
            <button className="navbar-button" onClick={handleClick}>
              Join Now
            </button>
          )}
           {isAuthenticated && (role === "actor" || role === "crew") && (
            <NotificationBell />
           )}
          {isAuthenticated && (role === "actor" || role === "crew") && (
          
                
                   <div className="subscribe-button-wrapper">
              <button
                className="subscribe-button"
                onClick={handleClickSubscribe}
              >
                SUBSCRIBE NOW
              </button>
            </div> 
           
          )}

          {isAuthenticated && (role === "director" || role === "producer") && (
            <NotificationBell />
           )}
          {isAuthenticated && (role === "director" || role === "producer") && (
            <div className="subscribe-button-wrapper">
              <button
                className="subscribe-button"
                onClick={handleClickCastingCallCreate}
              >
                POST A CASTING CALL
              </button>
            </div>
          )}
        </div>
        <FontAwesomeIcon
          icon={faBars}
          className="nav-menu-icon"
          onClick={toggleDrawer(true)}
        />
      </div>
      <LoginPopup
        isLoginOpen={isLoginOpen}
        setIsLoginOpen={setIsLoginOpen}
        redirectTo={redirectTo}
        setRedirectTo={setRedirectTo}
      />
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List className="drawer-wrapper">
          <div className="drawer-close-icon" onClick={toggleDrawer(false)}>
            <FontAwesomeIcon icon={faTimes} />{" "}
          </div>
          <div className="drawer-top-container">
            <NavLink to="/">
              <img src={logo} alt="" className="drawer-logo" />
            </NavLink>
            {!isAuthenticated && (
              <button
                className="navbar-button"
                onClick={() => {
                  handleClick();
                  toggleDrawer(false);
                }}
              >
                SIGN UP
              </button>
            )}
            {!isAuthenticated && (
              <NavLink
                to="/login"
                className="navLink"
                
                style={{ color: "#6e0506" }}
                onClick={(e) => {
                  e.preventDefault();
                  setIsLoginOpen(true);
                  toggleDrawer(false);
                }}
              >
                Login
              </NavLink>
            )}
               {isAuthenticated && (role === "actor" || role === "crew") && (
            <NotificationBell />
           )}
            {isAuthenticated && (role === "actor" || role === "crew") && (
              <div className="subscribe-button-wrapper">
                <button
                  className="subscribe-button"
                  onClick={() => {
                    handleClickSubscribe();
                    toggleDrawer(false);
                  }}
                > 
                  SUBSCRIBE NOW
                </button>
              </div>
            )}

          {isAuthenticated && (role === "director" || role === "producer") && (
            <NotificationBell />
           )}
            {isAuthenticated &&
              (role === "director" || role === "producer") && (
                <div className="subscribe-button-wrapper">
                  <button
                    className="subscribe-button"
                    onClick={() => {
                      handleClickCastingCallCreate();
                      toggleDrawer(false);
                    }}
                  >
                    POST A CASTING CALL
                  </button>
                </div>
              )}
            <div className="seperate-line"></div>
          </div>
          <ListItemButton
            onClick={toggleDrawer(false)}
            sx={{ paddingLeft: "40px" }}
          >
            <NavLink to="/castingcalls" end className="navLink">
              <ListItemText primary="Casting Calls" />
            </NavLink>
          </ListItemButton>
          {(!isAuthenticated || role !== "producer") && (
            <ListItemButton
              onClick={() => {
                if (!isAuthenticated) {
                  setRedirectTo("/actors");
                  setIsLoginOpen(true);
                }
                toggleDrawer(false);
              }}
              sx={{ paddingLeft: "40px" }}
            >
              <NavLink
                to="/actors"
                end
                className="navLink"
                onClick={(e) => !isAuthenticated && e.preventDefault()}
              >
                <ListItemText primary="Actors" />
              </NavLink>
            </ListItemButton>
          )}

          {!isAuthenticated || role !== "director" ? (
            <ListItemButton
              onClick={() => {
                if (!isAuthenticated) {
                  setRedirectTo("/crew");
                  setIsLoginOpen(true);
                }
                toggleDrawer(false);
              }}
              sx={{ paddingLeft: "40px" }}
            >
              <NavLink
                to="/crew"
                end
                className="navLink"
                onClick={(e) => !isAuthenticated && e.preventDefault()}
              >
                <ListItemText primary="Crew" />
              </NavLink>
            </ListItemButton>
          ) : null}
          {!isAuthenticated && (
            <ListItemButton
              onClick={toggleDrawer(false)}
              sx={{ paddingLeft: "40px" }}
            >
              <NavLink to="/castingdirectors" end className="navLink">
                <ListItemText primary="Casting Directors" />
              </NavLink>
            </ListItemButton>
          )}
          <ListItemButton
            onClick={toggleDrawer(false)}
            sx={{ paddingLeft: "40px" }}
          >
            <NavLink to="/reviews" end className="navLink">
              <ListItemText primary="Reviews" />
            </NavLink>
          </ListItemButton>
        </List>
      </Drawer>
    </div>
  );
};

export default NavBar;
